// src/pages/RepayLoan.js
import React, { useState, useEffect, memo } from 'react';
import './repay-loan.css';

import iciciQr from '../assets/images/icici-bank-logo.png'; 
import idfcQr from '../assets/images/idfcqrcode (1).jpg';   
import iciciLogo from '../assets/images/icici.png';         
import idfcLogo from '../assets/images/idfc_logo_for_ac.jpg'; 
import federalLogo from '../assets/images/federal-bank.png'; 
import federalQr from '../assets/images/federal-qrcode.jpeg';   

const banks = [
  {
    name: 'FEDERAL BANK',
    logo: federalLogo,
    qr: federalQr,
    upi: 'vmc1@fbl',
    accountName: 'Vanshika Micro Credit Private Limited.',
    accountNumber: '19110200004261',
    ifsc: 'FDRL0001911',
    branch: 'Green Park, New Delhi',
    accountType: 'Current Account',
  },
];

// Memoized Bank Card
const BankCard = memo(({ bank }) => (
  <div className="row align-items-center repay-card mb-5 p-4 shadow rounded-4 bg-white">
    <div className="col-md-7 mb-4 mb-md-0">
      <div className="text-center mb-3">
        <img src={bank.logo} alt={`${bank.name} logo`} className="bank-logo mb-2" style={{ height: '60px' }} />
      </div>
      <h4 className="fw-bold text-primary">Bank Details</h4>
      <div className="bank-details ps-md-3">
        <p><strong>Bank Name:</strong> {bank.name}</p>
        <p><strong>Company Name:</strong> {bank.accountName}</p>
        <p><strong>Account No.:</strong> {bank.accountNumber}</p>
        <p><strong>IFSC Code:</strong> {bank.ifsc}</p>
        <p><strong>Branch Name:</strong> {bank.branch}</p>
        <p><strong>Account Type:</strong> {bank.accountType}</p>
      </div>
    </div>

    <div className="col-md-5 text-center">
      <h4 className="fw-bold text-primary">QR Code / UPI</h4>
      <p className="fw-semibold">SCAN & PAY</p>

      {bank.qr && (
        <img
          src={bank.qr}
          alt={`${bank.name} QR Code`}
          className="qr-image mb-3"
          style={{ width: '260px', borderRadius: '10px' }}
        />
      )}

      {bank.upi && (
        <p className="mb-0"><strong>UPI ID:</strong> {bank.upi}</p>
      )}
    </div>
  </div>
));

const RepayLoan = () => {
  const [mobile, setMobile] = useState('');
  const [customer, setCustomer] = useState(null);
  const [error, setError] = useState('');
  const [paying, setPaying] = useState(false);
  const [payUing, setPayUing] = useState(false);

    /* ===== Load Paytm SDK (STAGING) ===== */
  useEffect(() => {
    const script = document.createElement("script");
    script.src =
      "https://secure.paytmpayments.com/merchantpgpui/checkoutjs/merchants/Vanshi31581444435768.js";
    script.async = true;

    script.onload = () => console.log("✅ Paytm SDK Loaded");
    script.onerror = () => console.error("❌ Paytm SDK Failed");

    document.body.appendChild(script);

    return () => {
      if (window.Paytm?.CheckoutJS) {
        window.Paytm.CheckoutJS.close();
      }
      document.body.removeChild(script);
    };
  }, []);

  // Search customer by mobile or PAN
  const handleSearch = async (e) => {
    e.preventDefault();
    setError("");
    setCustomer(null);

    try {
      const response = await fetch(
        `https://dhanwalle.in/Api/TaskApi/oldUserHistory?pancard=${mobile}`
      );
      const data = await response.json();

      if (data?.listTask?.length > 0) {
        const user = data.listTask[0];

        setCustomer({
          name: user.first_name,
          mobile: user.mobile,
          lead_id: user.lead_id,
          loan_no: user.loan_no,
          pan: user.pancard,
          repayAmount: user.total_repayable,
          tillDateRepayAmount: user.repayment_amount,
          repayDate: user.repayment_date,
          status: user.status,
          email: user.email || 'user@example.com',
          id: user.id || 'CUS',
        });

        setError('');
      } else {
        setCustomer(null);
        setError('Customer not found');
      }
    } catch (err) {
      console.error(err);
      setCustomer(null);
      setError('Something went wrong. Please try again later.');
    }
  };

  
  /* ===== PAY NOW (FIXED) ===== */
const payNow = async () => {
  if (paying) return;

  if (!window.Paytm || !window.Paytm.CheckoutJS) {
    alert("Paytm SDK not loaded");
    return;
  }

  setPaying(true);

  try {
    // ⚠️ FORM URL ENCODED (MOST IMPORTANT)
    // Test flow: backend uses callback URL → /payment-success-repay-test (live untouched)
    const res = await fetch("https://dhanwalle.in/paytm1/initiate", {
      method: "POST",
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
      },
      body: `amount=${encodeURIComponent(customer.repayAmount)}&lead_id=${encodeURIComponent(customer.lead_id)}&loan_no=${encodeURIComponent(customer.loan_no)}`,
    });

    if (!res.ok) {
      throw new Error("Server error: " + res.status);
    }

    const resp = await res.json();
    console.log("PAYTM INIT RESP:", resp);

    if (!resp.status) {
      alert(resp.message || "Transaction init failed");
      setPaying(false);
      return;
    }

    // ✅ INIT ONLY INSIDE CLICK
    await window.Paytm.CheckoutJS.init({
      flow: "DEFAULT",
      data: {
        orderId: resp.orderId,
        token: resp.txnToken,
        tokenType: "TXN_TOKEN",
        amount: resp.amount,
      },
      handler: {
        notifyMerchant: function (eventName, data) {
          console.log("PAYTM EVENT:", eventName, data);
        },
      },
    });

    // ✅ THIS LINE IS CRITICAL
    window.Paytm.CheckoutJS.invoke();

  } catch (err) {
    console.error("PAY ERROR:", err);
    alert("Payment failed");
  } finally {
    setPaying(false);
  }
};

const payUNow = async () => {
  if (payUing || !customer) return;

  setPayUing(true);

  try {

    const params = new URLSearchParams();
    params.append("amount", customer.repayAmount);
    params.append("lead_id", customer.lead_id);
    params.append("name", customer.name);
    params.append("email", customer.email);
    params.append("mobile", customer.mobile);
    params.append("loan_no", customer.loan_no);


    // Test flow: backend uses return URL → /payment-success-repay-test (live untouched)
    const res = await fetch("https://dhanwalle.in/payu1/generatePayUHash", {
      method: "POST",
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
      },
      body: params.toString(),
    });

    if (!res.ok) {
      throw new Error("Server error");
    }

    const resp = await res.json();
    console.log("PAYU RESP:", resp);

    if (!resp.status) {
      alert(resp.message || "PayU init failed");
      return;
    }

    // ✅ Create & submit PayU form
    const form = document.createElement("form");
    form.method = "POST";
    form.action = resp.payu_url;

    for (const key in resp.params) {
      const input = document.createElement("input");
      input.type = "hidden";
      input.name = key;
      input.value = resp.params[key];
      form.appendChild(input);
    }

    document.body.appendChild(form);
    form.submit();

  } catch (error) {
    console.error("PAYU ERROR:", error);
    alert("Payment failed. Please try again.");
  } finally {
    setPayUing(false);
  }
};



  return (
    <div className="repay-loan-page">

      {/* Hero Section */}
      <section className="hero-section text-white text-center py-3">
        <div className="container">
          <h1 className="fw-bold">Repay Your Loan</h1>
          <p className="lead mt-3 repay-subtitle">
            Choose your preferred bank and make hassle-free repayments.
          </p>
        </div>
      </section>

      {/* Search Form */}
      <section className="container mt-5">
        <form onSubmit={handleSearch} className="d-flex flex-column flex-md-row align-items-md-center gap-3 mb-4">
          <input
            type="text"
            className="form-control"
            placeholder="Enter Mobile Number / PAN Number"
            value={mobile}
            onChange={(e) => setMobile(e.target.value)}
            required
          />
          <button type="submit" className="btn custom-submit-btn">Submit</button>
        </form>

        {error && <div className="alert alert-danger">{error}</div>}

        {/* Customer Details Table */}
        {customer && (
          <div className="table-responsive mb-5">
            <table className="table table-bordered text-center align-middle">
              <thead className="table-light">
                <tr>
                  <th>Customer Name</th>
                  <th>Mobile Number</th>
                  <th>PAN No</th>
                  <th>Repay Amount</th>
                  <th>Till Date Repay Amount</th>
                  <th>Status</th>
                  <th>Repay Date</th>
                  <th>Paytm</th>
                  <th>PayU</th>

                </tr>
              </thead>

              <tbody>
                <tr>
                  <td>{customer.name}</td>
                  <td>{customer.mobile}</td>
                  <td>{customer.pan}</td>
                  <td>₹{customer.tillDateRepayAmount}</td>
                  <td>₹{customer.repayAmount}</td>
                  <td>{customer.status}</td>
                  <td>{customer.repayDate}</td>
                  <td>
                    <form>
                     <button
                    type="button"
                    className="btn btn-success btn-sm"
                    onClick={payNow}
                    disabled={paying}
                  >
                    {paying ? "Processing..." : "Pay Now"}
                  </button>
                    </form>
                  </td>

                  <td>
                    <form>
                     <button
                      type="button"
                      className="btn btn-success btn-sm"
                      onClick={payUNow}
                      disabled={payUing}
                    >
                      {payUing ? "Processing..." : "PayU Now"}
                    </button>

                    </form>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        )}
      </section>

      {/* Bank Cards */}
      <section className="mt-5 bg-light">
        <div className="container">
          {banks.map((bank, index) => (
            <BankCard key={index} bank={bank} />
          ))}
        </div>
      </section>
    </div>
  );
};

export default RepayLoan;
